import React, { useRef } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { GridColumn, Grid } from '@progress/kendo-react-grid';
import { Col, Row } from 'react-bootstrap';
import { v4 as uuid } from 'uuid';
import { GenericProductGetGridDTO, ProductGetMinGtinDto } from 'svila-common';
import WhitePad from '../../../../components/common/WhitePad/WhitePad';
import { withState } from '../../../../components/common/grid/WrappedGrid';
import { API_URL } from '../../../../utils/constants';
import TitleComponent from '../../../../components/common/forms/Title/TitleComponent';
import GtinComponent from '~/src/components/common/GtinComponent';
import GridWrapper from '~/src/components/common/GridWrapper';
import createIcon from '~/src/static/img/createIcon.svg';

export default function InventoryAddSelectProduct(): JSX.Element {
  const stateRef = useRef(null);
  const history = useHistory();
  const url = `${API_URL}/products/generics/get`;
  const StatefullGrid = withState(Grid, url);

  const ProductNameCell = (row: GenericProductGetGridDTO): JSX.Element => {
    const { dataItem } = row;
    
    return (
      <td>
        <Link to={`/inventory/add/${dataItem.id}`}>{dataItem?.name}</Link>
      </td>
    );
  };

  const BarcodeCell = ({ dataItem }): JSX.Element => {
    return (
      <td>
        {dataItem.gtins.map((item: ProductGetMinGtinDto) => (
          <div key={uuid()} style={{ display: 'flex' }}>
            <GtinComponent text="CU" code={item?.cuGtin} />
            <GtinComponent text="DU" code={item?.duGtin} />
            <b>Manuf.:</b>
            {item.manufacturerName}
            <br />
          </div>
        ))}
      </td>
    );
  };

  return (
    <WhitePad isFluid>
      <TitleComponent
        title="New Incoming Products"
        onLeftHandler={(): void => {
          history.push(`/inventory`);
        }}
        onRightHandler={(): void => {
        history.push('/products/create');
        }}
        titleRight="Create new product"
        iconRight={createIcon}
      />
      <Row>
        <Col>
          <GridWrapper>
            <StatefullGrid ref={stateRef} style={{ width: '100%' }}>
              <GridColumn field="name" title="Name" cell={(row) => ProductNameCell(row)} />
              <GridColumn field="gtin" title="Barcode" cell={BarcodeCell} />
            </StatefullGrid>
          </GridWrapper>
        </Col>
      </Row>
    </WhitePad>
  );
}
